import React from "react"
import { Container, MainTitle, Content, Item, Title, Text, Wrapper, SocialLink, ItemWrapper } from "./styles/actorInfo"
import { Container as MainContainer } from "../../containers"
import { Icon } from "../../components"

export default function ActorInfo({ children, ...rest }) {
  return <Container {...rest}>{children}</Container>
}

ActorInfo.Heading = function ActorInfoHeading({ children, ...rest }) {
  return (
    <MainTitle {...rest}>
      <MainContainer>{children}</MainContainer>
    </MainTitle>
  )
}

ActorInfo.Content = function ActorInfoContent({ children, ...rest }) {
  return (
    <Content {...rest}>
      <MainContainer>
        <Wrapper {...rest}>{children}</Wrapper>
      </MainContainer>
    </Content>
  )
}

ActorInfo.Wrapper = function ActorInfoWrapper({ children, ...rest }) {
  return <Wrapper {...rest}>{children}</Wrapper>
}

ActorInfo.Item = function ActorInfoItem({ children, ...rest }) {
  return <Item {...rest}>{children}</Item>
}

ActorInfo.Title = function ActorInfoTitle({ children, ...rest }) {
  return <Title {...rest}>{children}</Title>
}

ActorInfo.Text = function ActorInfoText({ children, ...rest }) {
  return <Text {...rest}>{children}</Text>
}

ActorInfo.SocialLink = function ActorInfoSocialLink({ name, ...rest }) {
  return (
    <SocialLink {...rest}>
      <Icon name={name} />
    </SocialLink>
  )
}

ActorInfo.ItemWrapper = function ActorInfoItemWrapper({ children, ...rest }) {
  return <ItemWrapper {...rest}>{children}</ItemWrapper>
}
